import React, { useCallback, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { PrimaryLayout } from '../Layout';

function PrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const isSaved = props?.formFields?.ROWID && props.formFields.ROWID !== "00000000-0000-0000-0000-000000000000";

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        if (!props.formRefs?.current?.[name]) return;
        const ref = props.formRefs.current[name];
        if (!ref?.instance) return;

        ref.instance().option('dataSource', dataSource);
        ref.instance().option('valueExpr', valueExpr);
        ref.instance().option('displayExpr', displayExpr);

        const currentValue = props.formFields?.[name];
        if (currentValue !== undefined) {
            ref.instance().option('value', currentValue);
        }
    }, [props.formRefs, props.formFields]);

    const setFieldDisabled = useCallback((name, disabled) => {
        const ref = props.formRefs?.current?.[name];
        if (ref?.instance) {
            ref.instance().option('disabled', disabled);
        }
    }, [props.formRefs]);

    const applyItemClassRule = useCallback((scheduleType) => {
        const isItemSchedule = scheduleType === 'I';
        setFieldDisabled('ITEMCLASS', !isItemSchedule);
        setFieldDisabled('ITEMSUBCLASS', !isItemSchedule);

        if (!isItemSchedule) {
            // Clear item class and item sub class values
            const itemClassRef = props.formRefs?.current?.['ITEMCLASS'];
            if (itemClassRef?.instance) {
                itemClassRef.instance().option('value', '');
            }
            const itemSubClassRef = props.formRefs?.current?.['ITEMSUBCLASS'];
            if (itemSubClassRef?.instance) {
                itemSubClassRef.instance().option('value', '');
            }
            props.setformFields(prev => ({
                ...prev,
                ITEMCLASS: '',
                ITEMSUBCLASS: ''
            }));
        }
    }, [props.formRefs, props.setformFields, setFieldDisabled]);

    const finalLayout = useMemo(() => {
        return PrimaryLayout;
    }, [isSaved]);

    const scheduleTypeOptions = [
        { id: 'I', text: 'Item Schedule' },
        { id: 'T', text: 'Transaction Schedule' },
        { id: 'S', text: 'Storage Transaction Schedule' }
    ];

    const handleSelectionChange = useCallback((name, value, e) => {
        props.handleFieldChange(name, value, e);

        if (name === 'SCHEDULETYPE') {
            setTimeout(() => {
                applyItemClassRule(value);
            }, 50);
        }
    }, [props.handleFieldChange, applyItemClassRule]);

    const applyEditModeRule = useCallback(() => {
        if (isSaved) {
            setFieldDisabled('R_PROFILECODE', true);
            setFieldDisabled('SCHEDULETYPE', true);
        }
    }, [isSaved, setFieldDisabled]);

    const handlePrimaryFormLoad = useCallback(() => {
        setTimeout(() => {
            loadLookupClient("SCHEDULETYPE", scheduleTypeOptions);
            applyItemClassRule(props.formFields?.SCHEDULETYPE);
            applyEditModeRule();
        }, 100);
    }, [loadLookupClient, applyItemClassRule, applyEditModeRule, props.formFields?.SCHEDULETYPE]);

    useEffect(() => {
        loadLookupClient("SCHEDULETYPE", scheduleTypeOptions);
    }, [loadLookupClient, props.formFields?.SCHEDULETYPE]);

    // Apply the business rule whenever SCHEDULETYPE changes
    useEffect(() => {
        applyItemClassRule(props.formFields?.SCHEDULETYPE);
    }, [props.formFields?.SCHEDULETYPE, applyItemClassRule]);

    // Apply edit mode rule when record is saved/loaded
    useEffect(() => {
        applyEditModeRule();
    }, [isSaved, applyEditModeRule]);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='14E6CC50-9961-4163-A865-FCBC469914E4'
                layoutName='WMRateScheduleCodePrimaryForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(PrimaryTab);

